const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmail(email) {
  if (!email) {
    return 'Email adresa je obavezna.';
  }

  if (!EMAIL_PATTERN.test(email)) {
    return 'Unesite ispravnu email adresu.';
  }

  return null;
}
